import {
  TrainingCategory,
  TrainingImage,
  TrainingContent,
  TrainingQuiz,
  TrainingQuizAnswerPayload,
  TrainingProgress,
  AppliedTraining,
  TrainingAccord,
} from "./../model/TrainingModel";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable()
export class TrainingService {
  constructor(private http: HttpClient) {}

  public listTrainings(clientId: number): Observable<Array<TrainingCategory>> {
    return this.http.get<Array<TrainingCategory>>(
      environment.apiHost +
        "/education/administration/categoria/list/cliente/" +
        clientId
    );
  }

  public listAppliedTrainings(
    userId: number
  ): Observable<Array<TrainingCategory>> {
    return this.http.get<Array<TrainingCategory>>(
      environment.apiHost + "/education/curso/aplicado/list/aluno/" + userId
    );
  }

  public getAccordTraining(
    clientId: number,
    termoId: number
  ): Observable<TrainingAccord> {
    return this.http.get<TrainingAccord>(
      environment.apiHost +
        "/education/administration/termo/cliente/" +
        clientId +
        "/termo/" +
        termoId
    );
  }

  public getImageTraining(
    clientId: number,
    imageId: number
  ): Observable<TrainingImage> {
    return this.http.get<TrainingImage>(
      environment.apiHost +
        "/education/imagem/cliente/" +
        clientId +
        "/imagem/" +
        imageId
    );
  }

  public listTrainingContent(
    trainingId: number
  ): Observable<Array<TrainingContent>> {
    return this.http.get<Array<TrainingContent>>(
      environment.apiHost + "/education/curso/list/conteudo/curso/" + trainingId
    );
  }

  public listTrainingQuiz(
    clientId: number,
    quizList: Array<number>
  ): Observable<Array<TrainingQuiz>> {
    let observableBatch = [];
    if (quizList.length > 0) {
      quizList.forEach((quizId) => {
        observableBatch.push(this.getTrainingQuiz(clientId, quizId));
      });
    } else {
      observableBatch.push(Observable.of(new Array<TrainingQuiz>()));
    }
    return Observable.forkJoin(observableBatch);
  }

  public getTrainingQuiz(
    clientId: number,
    quizId: number
  ): Observable<TrainingQuiz> {
    return this.http.get<TrainingQuiz>(
      environment.apiHost +
        "/education/administration/builder/quiz/cliente/" +
        clientId +
        "/quiz/" +
        quizId
    );
  }

  public saveTrainingQuiz(payload: TrainingQuizAnswerPayload): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post(
      environment.apiHost + "/education/curso/realiza/quiz/save",
      JSON.stringify(payload),
      { headers: headers, responseType: "text" }
    );
  }

  public getAnswerQuiz(
    clientId: number,
    alunoId: number,
    cursoId: number,
    quizId: number,
    pageId: number
  ): Observable<Array<TrainingQuizAnswerPayload>> {
    return this.http.get<Array<TrainingQuizAnswerPayload>>(
      environment.apiHost +
        "/education/curso/realiza/quiz/resposta/list/cliente/" +
        clientId +
        "/aluno/" +
        alunoId +
        "/curso/" +
        cursoId +
        "/quiz/" +
        quizId +
        "/pagina/" +
        pageId
    );
  }

  public saveTrainingProgress(payload: TrainingProgress): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post(
      environment.apiHost + "/education/curso/realiza/status/save",
      JSON.stringify(payload),
      { headers: headers, responseType: "text" }
    );
  }

  public getTrainingProgress(
    clientId: number,
    alunoId: number,
    cursoId: number
  ): Observable<Array<TrainingProgress>> {
    return this.http.get<Array<TrainingProgress>>(
      environment.apiHost +
        "/education/curso/realiza/status/progress/cliente/" +
        clientId +
        "/aluno/" +
        alunoId +
        "/curso/" +
        cursoId
    );
  }

  public saveTrainingStatus(payload: AppliedTraining): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post(
      environment.apiHost + "/education/administration/curso/aplica/update",
      JSON.stringify(payload),
      { headers: headers, responseType: "text" }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/TrainingSevice.ts